export const VERIFY_EVENTS = {
  VIEW_AUTH_ENTER_OTP: 'view_auth_enter_otp',
  SELECT_AUTH_VERIFY_OTP: 'select_auth_verify_otp',
  VERIFY_TOKEN: 'verify_token',
  API_AUTH_VERIFY_OTP_SUCCESS: 'api_auth_verify_otp_success',
  API_AUTH_VERIFY_OTP_ERROR: 'api_auth_verify_otp_error',
  API_AUTH_VERIFY_OTP_NO_CODE: 'api_auth_verify_otp_no_code',
  SELECT_AUTH_RESEND_OTP: 'select_auth_resend_otp',
  API_AUTH_RESEND_OTP_ERROR: 'api_auth_resend_otp_error',
  API_GET_TOKEN_NO_CODE: 'api_get_token_no_code',
  API_GET_TOKEN_CATCH_ERROR: 'api_get_token_catch_error',
} as const;
